import { CmObjectType } from '../cta/CmObjectType.js';

/**
 * Common Media Server Data Object Type
 *
 * @group CMSD
 *
 * @enum
 *
 * @beta
 */
export const CmsdObjectType = CmObjectType as typeof CmObjectType;

/**
 * @beta
 */
export type CmsdObjectType = CmObjectType;
